/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

/**
 * Performs a lightweight email address check.
 *
 * @param email - Value to validate.
 * @returns `true` when the value has non-empty local and domain parts, a dotted domain,
 *   and no whitespace.
 *
 * @remarks
 * This is intentionally permissive. It catches common input mistakes without attempting
 * full RFC 5322 validation; the backend remains authoritative.
 */
export function isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
